/**
 * InboxItemType
 *
 * The closed set of row kinds rendered in the unified inbox `VirtualList`.
 * Drives the `InboxItem` discriminated union (Task 7) that flattens the two
 * inbox feeds (notifications + direct messages) into a single list:
 *  - `notificationsHeader` — the "Updates" section header row.
 *  - `notification`        — a single notification row.
 *  - `moreNotifications`   — the collapsible "More updates" toggle row.
 *  - `chatHeader`          — the "Direct messages" section header row.
 *  - `chatMessage`         — a single chat-node (conversation) row.
 *
 * Web-only concept: Flutter's MessagesScreen uses separate sliver delegates
 * rather than a single typed item model, so there is no Flutter enum to
 * ordinal-match. A string-valued enum is used for clearer debugging. Per
 * `conventions.md` § "Enums live in the domain layer", it lives in the domain
 * layer even though its first consumer is presentation-local.
 */
export enum InboxItemType {
  notificationsHeader = 'notificationsHeader',
  notification = 'notification',
  moreNotifications = 'moreNotifications',
  chatHeader = 'chatHeader',
  chatMessage = 'chatMessage',
}
